import type { WashedLocale } from '@washed/i18n';

export const LOCALE_PREFERENCE_COOKIE = 'washed_locale';

const ONE_YEAR_SECONDS = 60 * 60 * 24 * 365;

/** Persist only an explicit user choice. The edge middleware reads this cookie. */
export function rememberLocalePreference(locale: WashedLocale): void {
  if (typeof document === 'undefined') return;

  const secure =
    typeof window !== 'undefined' && window.location.protocol === 'https:' ? '; Secure' : '';

  document.cookie = `${LOCALE_PREFERENCE_COOKIE}=${locale}; Path=/; Max-Age=${ONE_YEAR_SECONDS}; SameSite=Lax${secure}`;
}
